export default __webpack_public_path__ + "static/media/Land and sea1.09efb0ce.jpg";